import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as SearchActions from '../actions/hearings-search.actions';
import { HearingSearchResourceService } from 'src/app/services/NewSearchDataWebService';

@Injectable()
export class HearingSearchEffects {
  searchHearings$ = createEffect(() => this.actions$.pipe(
    ofType(SearchActions.searchHearings),
    mergeMap(action =>
      this.hearingSearchService.searchHearingDetailWithDSL1(
        action.payload,
        action.includePendingActionDocs,
        action.includeDocCountByDocumentType
      ).pipe(
        map(response => SearchActions.searchHearingsSuccess({
          response,
          context: action.context // Passing the context along with the response
        })),
        catchError(error => of(SearchActions.searchHearingsFailure({
          error,
          context: action.context // Passing the context along with the error
        })))
      )
    )
  ));

  constructor(
    private actions$: Actions,
    private hearingSearchService: HearingSearchResourceService
  ) {}
}
